import React from 'react';
import RegularTablesList from './RegularTablesList';
import { Modify } from 'utils/types';
import { RouteComponentProps } from 'react-router-dom';

export { default as AddEditRegularTableModal } from './Components/AddEditRegularTableModal';

export type RegularTablesContainerProps = Modify<
  RouteComponentProps,
  {
    match: { params: { restaurantId: string } };
  }
>;

const RegularTablesContainer = ({ match }: RegularTablesContainerProps) => {
  return <RegularTablesList restaurantId={match.params.restaurantId} />;
};

export default RegularTablesContainer;
